class StickyAtcV2 extends HTMLElement {
  connectedCallback() {
    this.productSection = document.getElementById(this.dataset.productSection);
    if (!this.productSection) return;

    this.footer = document.querySelector('footer') || document.querySelector('[id*="footer"]');

    this.productObserver = new IntersectionObserver(
      ([entry]) => {
        this.productOutOfView = !entry.isIntersecting;
        this.update();
      },
      { threshold: 0 },
    );
    this.productObserver.observe(this.productSection);

    if (this.footer) {
      this.footerObserver = new IntersectionObserver(
        ([entry]) => {
          this.footerInView = entry.isIntersecting;
          this.update();
        },
        { threshold: 0 },
      );
      this.footerObserver.observe(this.footer);
    }

    this.querySelector('.sticky-atc-v2__button').addEventListener('click', () => {
      this.scrollTo(this.buyTarget);
    });

    this.setupTabs();
  }

  get buyTarget() {
    return this.firstVisible('related-product-buttons') || this.productSection;
  }

  firstVisible(selector) {
    return [...document.querySelectorAll(selector)].find((element) => element.getClientRects().length > 0) || null;
  }

  disconnectedCallback() {
    this.productObserver?.disconnect();
    this.footerObserver?.disconnect();
  }

  setupTabs() {
    this.querySelectorAll('.sticky-atc-v2__tab').forEach((tab) => {
      const target = this.resolveTarget(tab);
      if (!target) {
        tab.hidden = true;
        return;
      }
      const nudge = Number(tab.dataset.anchorNudge) || 0;
      tab.addEventListener('click', () => this.scrollTo(target, nudge));
    });
  }

  hasContent(element) {
    if (element.offsetHeight === 0) return false;
    return element.innerText.trim() !== '' || !!element.querySelector('img, video, iframe');
  }

  resolveTarget(tab) {
    const selectors = (tab.dataset.anchor || '').split('|').map((selector) => selector.trim());
    for (const selector of selectors) {
      if (!selector) continue;
      const match = document.querySelector(selector);
      if (!match) continue;
      const section = match.closest('[id^="shopify-section"]') || match;
      if (tab.dataset.anchorAlways !== 'true' && !this.hasContent(section)) continue;
      if (tab.dataset.anchorPreferLead === 'true') {
        const lead = section.previousElementSibling;
        if (lead?.id?.startsWith('shopify-section') && lead.offsetHeight > 0) return lead;
      }
      return section;
    }
    return null;
  }

  get headerOffset() {
    const header = document.querySelector('l-header');
    if (!header) return 0;
    const position = getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return 0;
    return header.getBoundingClientRect().height;
  }

  scrollTo(element, nudge = 0) {
    const top = element.getBoundingClientRect().top + window.scrollY - this.headerOffset + nudge;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  update() {
    this.classList.toggle('is-visible', this.productOutOfView && !this.footerInView);
  }
}

if (!customElements.get('sticky-atc-v2')) {
  customElements.define('sticky-atc-v2', StickyAtcV2);
}
